
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification, UserDetailsView, UserDetailsViewService } from '@scisys-uim/uim-common';
import { Observable } from 'rxjs';


export class UsersDataSource extends CrudDataSource<UserDetailsView> {


  constructor(private userService: UserDetailsViewService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<UserDetailsView>> {
    return this.userService.findByFullFilter(serviceArguments, pageSpec);
  }


}
